import { CommonModule } from '@angular/common';
import { InjectionToken, Injectable, Inject, Component, ViewEncapsulation, Input, Directive, ViewContainerRef, Renderer2, ComponentFactoryResolver, ElementRef, NgModule } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

function CgBusyComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵelement(2, "div", 6);
    ɵngcc0.ɵɵelement(3, "div", 7);
    ɵngcc0.ɵɵelement(4, "div", 8);
    ɵngcc0.ɵɵelement(5, "div", 9);
    ɵngcc0.ɵɵelement(6, "div", 10);
    ɵngcc0.ɵɵelement(7, "div", 11);
    ɵngcc0.ɵɵelement(8, "div", 12);
    ɵngcc0.ɵɵelement(9, "div", 13);
    ɵngcc0.ɵɵelement(10, "div", 14);
    ɵngcc0.ɵɵelement(11, "div", 15);
    ɵngcc0.ɵɵelement(12, "div", 16);
    ɵngcc0.ɵɵelement(13, "div", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(14, "div", 18);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(14);
    ɵngcc0.ɵɵproperty("innerHtml", ctx_r1.options.message, ɵngcc0.ɵɵsanitizeHtml);
} }
const _c0 = function (a0) { return { options: a0 }; };
class CgBusyService {
    constructor() {
        this.promises = [];
        this.subscriptions = [];
    }
    // tslint:disable-next-line:no-any
    static isPromise(promiseThing) {
        return promiseThing && (promiseThing instanceof Promise || promiseThing instanceof Observable || promiseThing instanceof Subscription);
    }
    // tslint:disable-next-line:no-any
    callThen(promiseThing, callback) {
        if (promiseThing.finally) {
            promiseThing.finally(callback);
        }
        else if (promiseThing.then) {
            promiseThing.then(callback, callback);
        }
        else if (promiseThing instanceof Observable) {
            let subscription;
            const cc = () => {
                if (subscription) {
                    subscription.unsubscribe();
                }
                callback();
            };
            subscription = promiseThing.subscribe({ error: cc, complete: cc });
            this.subscriptions.push(subscription);
        }
        else if (promiseThing instanceof Subscription) {
            promiseThing.add(callback);
        }
        else {
            throw new Error('cgBusy expects a Promise ,an Observable, a Subscription, a number or a boolean');
        }
    }
    reset(options) {
        this.minDuration = options.minDuration;
        this.promises = [];
        options.promises.forEach((p) => {
            if (!p || p.$cgBusyFulfilled) {
                return;
            }
            this.addPromiseLikeThing(p);
        });
        if (this.promises.length === 0) {
            // if we have no promises then don't do the delay or duration stuff
            return;
        }
        if (options.delay) {
            this.delayPromise = setTimeout(() => {
                this.delayPromise = null;
                if (this.detectChanges) {
                    this.detectChanges();
                }
                this.createMinDuration(options);
            }, options.delay);
        }
        else {
            this.createMinDuration(options);
        }
    }
    createMinDuration(options) {
        if (options.minDuration) {
            this.durationPromise = setTimeout(() => {
                this.durationPromise = null;
                if (this.detectChanges) {
                    this.detectChanges();
                }
            }, options.minDuration);
        }
    }
    // tslint:disable-next-line:no-any
    addPromiseLikeThing(promise) {
        if (!CgBusyService.isPromise(promise)) {
            throw new Error('cgBusy expects a Promise ,an Observable, a Subscription, a number or a boolean');
        }
        if (this.promises.indexOf(promise) !== -1) {
            return;
        }
        this.promises.push(promise);
        this.callThen(promise, () => {
            promise.$cgBusyFulfilled = true;
            if (this.promises.indexOf(promise) === -1) {
                return;
            }
            this.promises.splice(this.promises.indexOf(promise), 1);
            if (this.delayPromise && this.promises.length === 0) {
                clearTimeout(this.delayPromise);
                this.delayPromise = null;
            }
            if (this.detectChanges) {
                this.detectChanges();
            }
        });
    }
    active() {
        return !this.delayPromise && (!!this.durationPromise || this.promises.length > 0);
    }
    destroy() {
        if (this.delayPromise) {
            clearTimeout(this.delayPromise);
            this.delayPromise = null;
        }
        if (this.durationPromise) {
            clearTimeout(this.durationPromise);
            this.durationPromise = null;
        }
        this.promises = [];
        this.subscriptions.forEach((subscription) => {
            subscription.unsubscribe();
        });
        this.subscriptions = [];
        this.detectChanges = null;
    }
}

const BUSY_OPTIONS = new InjectionToken('BUSY_OPTIONS');
class CgBusyDefaults {
    constructor(busyOptions) {
        if (!busyOptions) {
            busyOptions = {};
        }
        this.delay = busyOptions.delay || 0;
        this.minDuration = busyOptions.minDuration || 0;
        this.backdrop = busyOptions.backdrop !== undefined ? busyOptions.backdrop : true;
        this.message = busyOptions.message || 'Please Wait...';
        this.wrapperClass = busyOptions.wrapperClass || '';
    }
}
CgBusyDefaults.ɵfac = function CgBusyDefaults_Factory(t) { return new (t || CgBusyDefaults)(ɵngcc0.ɵɵinject(BUSY_OPTIONS)); };
CgBusyDefaults.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: CgBusyDefaults, factory: CgBusyDefaults.ɵfac });
CgBusyDefaults.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [BUSY_OPTIONS,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CgBusyDefaults, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [BUSY_OPTIONS]
            }] }]; }, null); })();

class CgBusyComponent {
}
CgBusyComponent.ɵfac = function CgBusyComponent_Factory(t) { return new (t || CgBusyComponent)(); };
CgBusyComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CgBusyComponent, selectors: [["cg-busy"]], inputs: { options: "options", tracker: "tracker" }, decls: 5, vars: 9, consts: [[3, "hidden"], [1, "cg-busy-backdrop", "cg-busy-backdrop-animation", 3, "hidden"], [1, "cg-busy-template", 3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["defaultTemplate", ""], [1, "cg-busy-default-sign"], [1, "cg-busy-default-spinner"], [1, "bar1"], [1, "bar2"], [1, "bar3"], [1, "bar4"], [1, "bar5"], [1, "bar6"], [1, "bar7"], [1, "bar8"], [1, "bar9"], [1, "bar10"], [1, "bar11"], [1, "bar12"], [1, "cg-busy-default-text", 3, "innerHtml"]], template: function CgBusyComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "div", 1);
        ɵngcc0.ɵɵelementContainer(2, 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, CgBusyComponent_ng_template_3_Template, 15, 1, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(4);
        ɵngcc0.ɵɵclassMapInterpolate1("cg-busy cg-busy-animation ", ctx.options.wrapperClass, "");
        ɵngcc0.ɵɵproperty("hidden", !ctx.tracker.active());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.options.backdrop);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.options.templateRef ? ctx.options.templateRef : _r0)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(7, _c0, ctx.options));
    } }, directives: [ɵngcc1.NgTemplateOutlet], styles: [".cg-busy,.cg-busy .cg-busy-backdrop,.cg-busy .cg-busy-template{bottom:0;height:100%;left:0;position:absolute;right:0;top:0;width:100%}.cg-busy{text-align:center;z-index:1001}.cg-busy-animation.ng-hide-add,.cg-busy-animation.ng-hide-remove{display:block!important;transition:all .3s ease}.cg-busy-animation.ng-hide-remove{opacity:0;transform:translateY(-40px)}.cg-busy-animation.ng-hide-add,.cg-busy-animation.ng-hide-remove.ng-hide-remove-active{opacity:1;transform:translate(0)}.cg-busy-animation.ng-hide-add.ng-hide-add-active{opacity:0;transform:translateY(-40px)}.cg-busy-backdrop{background-color:#fff;opacity:.7}.cg-busy-backdrop-animation.ng-hide-add,.cg-busy-backdrop-animation.ng-hide-remove{display:block!important;transition:opacity .3s ease}.cg-busy-backdrop-animation.ng-hide{opacity:0}.cg-busy-default-sign{background-color:#e9eeee;border:1px solid #ddd;border-radius:7px;border-top:0 solid #ddd;border-top-left-radius:0;border-top-right-radius:0;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.2),0 1px 2px rgba(0,0,0,.05);color:#333;display:inline-block;padding-bottom:6px;position:relative;text-shadow:0 1px 1px hsla(0,0%,100%,.75);z-index:1002}.cg-busy-default-text{color:#555;font-size:16px;margin:13px 12px 6px 49px;max-width:400px;text-align:left}.cg-busy-default-spinner{display:inline-block;height:25px;left:14px;position:absolute;top:12px;width:25px}.cg-busy-default-spinner div{animation:cg-busy-spinner-anim 1s linear infinite;background:#000;border-radius:50px;box-shadow:0 0 3px rgba(0,0,0,.2);height:26%;left:44.5%;opacity:0;position:absolute;top:37%;width:12%}.cg-busy-default-spinner div.bar1{animation-delay:0s;transform:rotate(0deg) translateY(-142%)}.cg-busy-default-spinner div.bar2{animation-delay:-.9167s;transform:rotate(30deg) translateY(-142%)}.cg-busy-default-spinner div.bar3{animation-delay:-.833s;transform:rotate(60deg) translateY(-142%)}.cg-busy-default-spinner div.bar4{animation-delay:-.75s;transform:rotate(90deg) translateY(-142%)}.cg-busy-default-spinner div.bar5{animation-delay:-.667s;transform:rotate(120deg) translateY(-142%)}.cg-busy-default-spinner div.bar6{animation-delay:-.5833s;transform:rotate(150deg) translateY(-142%)}.cg-busy-default-spinner div.bar7{animation-delay:-.5s;transform:rotate(180deg) translateY(-142%)}.cg-busy-default-spinner div.bar8{animation-delay:-.41667s;transform:rotate(210deg) translateY(-142%)}.cg-busy-default-spinner div.bar9{animation-delay:-.333s;transform:rotate(240deg) translateY(-142%)}.cg-busy-default-spinner div.bar10{animation-delay:-.25s;transform:rotate(270deg) translateY(-142%)}.cg-busy-default-spinner div.bar11{animation-delay:-.1667s;transform:rotate(300deg) translateY(-142%)}.cg-busy-default-spinner div.bar12{animation-delay:-.0833s;transform:rotate(330deg) translateY(-142%)}@keyframes cg-busy-spinner-anim{0%{opacity:1}to{opacity:.25}}"], encapsulation: 2 });
CgBusyComponent.propDecorators = {
    options: [{ type: Input }],
    tracker: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CgBusyComponent, [{
        type: Component,
        args: [{
                template: "<div class=\"cg-busy cg-busy-animation {{options.wrapperClass}}\" [hidden]=\"!tracker.active()\">\n  <div class=\"cg-busy-backdrop cg-busy-backdrop-animation\" [hidden]=\"!options.backdrop\"></div>\n  <ng-container class=\"cg-busy-template\"\n                [ngTemplateOutlet]=\"options.templateRef ? options.templateRef : defaultTemplate\"\n                [ngTemplateOutletContext]=\"{options: options}\"></ng-container>\n</div>\n<ng-template #defaultTemplate>\n  <div class=\"cg-busy-default-sign\">\n    <div class=\"cg-busy-default-spinner\">\n      <div class=\"bar1\"></div>\n      <div class=\"bar2\"></div>\n      <div class=\"bar3\"></div>\n      <div class=\"bar4\"></div>\n      <div class=\"bar5\"></div>\n      <div class=\"bar6\"></div>\n      <div class=\"bar7\"></div>\n      <div class=\"bar8\"></div>\n      <div class=\"bar9\"></div>\n      <div class=\"bar10\"></div>\n      <div class=\"bar11\"></div>\n      <div class=\"bar12\"></div>\n    </div>\n    <div class=\"cg-busy-default-text\" [innerHtml]=\"options.message\"></div>\n  </div>\n</ng-template>\n",
                selector: 'cg-busy',
                encapsulation: ViewEncapsulation.None,
                styles: [".cg-busy,.cg-busy .cg-busy-backdrop,.cg-busy .cg-busy-template{bottom:0;height:100%;left:0;position:absolute;right:0;top:0;width:100%}.cg-busy{text-align:center;z-index:1001}.cg-busy-animation.ng-hide-add,.cg-busy-animation.ng-hide-remove{display:block!important;transition:all .3s ease}.cg-busy-animation.ng-hide-remove{opacity:0;transform:translateY(-40px)}.cg-busy-animation.ng-hide-add,.cg-busy-animation.ng-hide-remove.ng-hide-remove-active{opacity:1;transform:translate(0)}.cg-busy-animation.ng-hide-add.ng-hide-add-active{opacity:0;transform:translateY(-40px)}.cg-busy-backdrop{background-color:#fff;opacity:.7}.cg-busy-backdrop-animation.ng-hide-add,.cg-busy-backdrop-animation.ng-hide-remove{display:block!important;transition:opacity .3s ease}.cg-busy-backdrop-animation.ng-hide{opacity:0}.cg-busy-default-sign{background-color:#e9eeee;border:1px solid #ddd;border-radius:7px;border-top:0 solid #ddd;border-top-left-radius:0;border-top-right-radius:0;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.2),0 1px 2px rgba(0,0,0,.05);color:#333;display:inline-block;padding-bottom:6px;position:relative;text-shadow:0 1px 1px hsla(0,0%,100%,.75);z-index:1002}.cg-busy-default-text{color:#555;font-size:16px;margin:13px 12px 6px 49px;max-width:400px;text-align:left}.cg-busy-default-spinner{display:inline-block;height:25px;left:14px;position:absolute;top:12px;width:25px}.cg-busy-default-spinner div{animation:cg-busy-spinner-anim 1s linear infinite;background:#000;border-radius:50px;box-shadow:0 0 3px rgba(0,0,0,.2);height:26%;left:44.5%;opacity:0;position:absolute;top:37%;width:12%}.cg-busy-default-spinner div.bar1{animation-delay:0s;transform:rotate(0deg) translateY(-142%)}.cg-busy-default-spinner div.bar2{animation-delay:-.9167s;transform:rotate(30deg) translateY(-142%)}.cg-busy-default-spinner div.bar3{animation-delay:-.833s;transform:rotate(60deg) translateY(-142%)}.cg-busy-default-spinner div.bar4{animation-delay:-.75s;transform:rotate(90deg) translateY(-142%)}.cg-busy-default-spinner div.bar5{animation-delay:-.667s;transform:rotate(120deg) translateY(-142%)}.cg-busy-default-spinner div.bar6{animation-delay:-.5833s;transform:rotate(150deg) translateY(-142%)}.cg-busy-default-spinner div.bar7{animation-delay:-.5s;transform:rotate(180deg) translateY(-142%)}.cg-busy-default-spinner div.bar8{animation-delay:-.41667s;transform:rotate(210deg) translateY(-142%)}.cg-busy-default-spinner div.bar9{animation-delay:-.333s;transform:rotate(240deg) translateY(-142%)}.cg-busy-default-spinner div.bar10{animation-delay:-.25s;transform:rotate(270deg) translateY(-142%)}.cg-busy-default-spinner div.bar11{animation-delay:-.1667s;transform:rotate(300deg) translateY(-142%)}.cg-busy-default-spinner div.bar12{animation-delay:-.0833s;transform:rotate(330deg) translateY(-142%)}@keyframes cg-busy-spinner-anim{0%{opacity:1}to{opacity:.25}}"]
            }]
    }], null, { options: [{
            type: Input
        }], tracker: [{
            type: Input
        }] }); })();

class CgBusyDirective {
    constructor(viewContainer, defaultOptions, renderer, componentFactoryResolver, el) {
        this.viewContainer = viewContainer;
        this.defaultOptions = defaultOptions;
        this.renderer = renderer;
        this.componentFactoryResolver = componentFactoryResolver;
        this.el = el;
        this.$options = Object.assign({}, this.defaultOptions);
        this.$promise = [];
        this.renderer.setStyle(this.el.nativeElement.parentNode, 'position', 'relative');
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(CgBusyComponent);
        this.componentRef = this.viewContainer.createComponent(componentFactory);
        this.tracker = new CgBusyService();
        this.tracker.detectChanges = () => this.componentRef.changeDetectorRef.detectChanges();
        this.componentRef.instance.tracker = this.tracker;
        this.componentRef.instance.options = this.$options;
    }
    ngOnChanges(changes) {
        if (changes.cgBusyConfig) {
            this.$options = Object.assign(Object.assign(Object.assign({}, this.defaultOptions), this.$options), this.cgBusyConfig);
            this.componentRef.instance.options = this.$options;
        }
        if (changes.cgBusy) {
            if (this.fakePromise) {
                this.fakePromiseResolve();
                this.fakePromise = undefined;
                this.fakePromiseResolve = undefined;
            }
            if (Number.isFinite(this.cgBusy) || this.cgBusy === true || this.cgBusy === false) {
                this.fakePromise = new Promise((resolve) => {
                    this.fakePromiseResolve = resolve;
                    if (!this.cgBusy) {
                        resolve();
                    }
                });
                this.$promise = [this.fakePromise];
            }
            else if (Array.isArray(this.cgBusy)) {
                this.$promise = this.cgBusy;
            }
            else {
                // @ts-ignore
                this.$promise = [this.cgBusy];
            }
        }
        this.tracker.reset({
            promises: this.$promise,
            delay: this.$options.delay || 0,
            minDuration: this.$options.minDuration || 0
        });
    }
    ngOnDestroy() {
        this.tracker.destroy();
        delete this.tracker;
        this.componentRef.destroy();
        delete this.componentRef;
        this.$promise = [];
        this.fakePromise = undefined;
        this.fakePromiseResolve = undefined;
    }
}
CgBusyDirective.ɵfac = function CgBusyDirective_Factory(t) { return new (t || CgBusyDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(CgBusyDefaults), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
CgBusyDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: CgBusyDirective, selectors: [["", "cgBusy", ""]], inputs: { cgBusy: "cgBusy", cgBusyConfig: "cgBusyConfig" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
CgBusyDirective.ctorParameters = () => [
    { type: ViewContainerRef },
    { type: CgBusyDefaults },
    { type: Renderer2 },
    { type: ComponentFactoryResolver },
    { type: ElementRef }
];
CgBusyDirective.propDecorators = {
    cgBusy: [{ type: Input }],
    cgBusyConfig: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CgBusyDirective, [{
        type: Directive,
        args: [{ selector: '[cgBusy]' }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }, { type: CgBusyDefaults }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.ElementRef }]; }, { cgBusy: [{
            type: Input
        }], cgBusyConfig: [{
            type: Input
        }] }); })();

function cgBusyDefaultsFactory(busyOptions) {
    return new CgBusyDefaults(busyOptions);
}
class CgBusyModule {
    static forRoot(busyOptions) {
        return {
            ngModule: CgBusyModule,
            providers: [
                {
                    provide: CgBusyDefaults,
                    useFactory: cgBusyDefaultsFactory,
                    deps: [BUSY_OPTIONS]
                },
                {
                    provide: BUSY_OPTIONS,
                    useValue: busyOptions
                }
            ]
        };
    }
}
CgBusyModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: CgBusyModule });
CgBusyModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function CgBusyModule_Factory(t) { return new (t || CgBusyModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CgBusyModule, { declarations: function () { return [CgBusyDirective, CgBusyComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [CgBusyDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CgBusyModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    CgBusyDirective,
                    CgBusyComponent
                ],
                imports: [
                    CommonModule
                ],
                exports: [CgBusyDirective]
            }]
    }], null, null); })();

/*
 * Public API Surface of angular-busy2
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CgBusyDefaults, CgBusyModule, cgBusyDefaultsFactory as ɵa, BUSY_OPTIONS as ɵb, CgBusyDirective as ɵc, CgBusyComponent as ɵd };

//# sourceMappingURL=angular-busy2.js.map